<template>
  <div class="page-content">
    <div
      class="page-content__header-description"
      style="display: flex; padding: 10px !important; flex-flow: column"
    >
      <!-- <h2>Device Performance</h2> -->
      <div style="display: flex; align-items: center; cursor: pointer">
        <el-breadcrumb separator="/" class="col-sm-6">
          <el-breadcrumb-item :to="{ path: '/' }">Dashboard</el-breadcrumb-item>
          <can I="read" a="all">
            <el-breadcrumb-item :to="{ path: '/performance/live' }"
              >Performance</el-breadcrumb-item
            >
          </can>
          <el-breadcrumb-item>{{ $route.params.deviceId }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="col-sm-6">
          <div class="pull-right" style="display: flex; flex-flow: row no-wrap">
            <!-- <can I="manage" a="user"> -->
            <b-button variant="success" @click="openBlank">Chart</b-button>
            <!-- <div v-if="isShow">
              <b-button
                variant="danger"
                :to="{
                  path: `/dashboard/performance/${$route.params.deviceId}`,
                }"
                >Charts</b-button
              >
            </div> -->
            <!-- </can> -->
            <div style="margin-left: 10px">
              <b-dropdown id="dropdown-1" text="View Options" class="m-md-2">
                <b-dropdown-item
                  active
                  @click="
                    handleSplitValue({ code: 0, name: 'System Overview' })
                  "
                  >System Overview</b-dropdown-item
                >
                <!-- <b-dropdown-item
                  @click="handleSplitValue({ code: 1, name: 'Chart' })"
                  >Chart</b-dropdown-item
                > -->
                <b-dropdown-item
                  @click="
                    handleSplitValue({ code: 2, name: 'Device Controls' })
                  "
                  >Device Controls</b-dropdown-item
                >
                <!-- <b-dropdown-divider></b-dropdown-divider> -->
                <!-- <b-dropdown-item>Active action</b-dropdown-item>
                <b-dropdown-item disabled>Disabled action</b-dropdown-item>-->
              </b-dropdown>
            </div>
            <can I="manage" a="installation">
              <div style="margin-left: 10px">
                <control-settings></control-settings>
              </div>
            </can>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <v2-dash
        :inverterId="$route.params.deviceId"
        v-if="$route.params.version == 'v2'"
        :screenView="screenView"
      ></v2-dash>
      <v3-dash
        :inverterId="$route.params.deviceId"
        v-if="$route.params.version == 'v3'"
        :screenView="screenView"
      ></v3-dash>
      <v4-dash
        :inverterId="$route.params.deviceId"
        v-if="$route.params.version == 'v4'"
        :screenView="screenView"
      ></v4-dash>
      <v5-dash
        :inverterId="$route.params.deviceId"
        v-if="$route.params.version == 'v5'"
        :screenView="screenView"
      ></v5-dash>
      <v6-dash
        :inverterId="$route.params.deviceId"
        v-if="$route.params.version == 'v6'"
        :screenView="screenView"
      ></v6-dash>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import {
  Carousel,
  CarouselItem,
  Breadcrumb,
  BreadcrumbItem,
  Notification,
  Collapse,
  CollapseItem
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import GreyChart from "../kitchen/grey-chart";
import InstallationStat from "./installationStat";
import dummyData from "./dummy.json";
import v2Dash from "./detailsV3/v2.vue";
import v3Dash from "./detailsV3/v3.vue";
import controlSettings from "./controls/index.vue";
import v4Dash from "./detailsV3/v4.vue";
import v5Dash from "./detailsV3/v5.vue";
import v6Dash from "./detailsV3/v6.vue";
import Battery from "../kitchen/grey-battery";
import moment from "moment";
import { HTTP as IOTHTTP } from "../../../store/actions";
// import flatPickr from "vue-flatpickr-component";
import RightBar from "../rightBar";
// import "flatpickr/dist/flatpickr.css";
import { mapGetters, mapActions } from "vuex";
// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
const endies = "https://iot-solarbase.arnergy.com/event/publish";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Collapse);
Vue.use(CollapseItem);

export default {
  name: "deviceDetails",
  components: {
    InstallationStat,
    GreyChart,
    Battery,
    datetime: Datetime,
    "v2-dash": v2Dash,
    "v3-dash": v3Dash,
    "v4-dash": v4Dash,
    "v5-dash": v5Dash,
    "v6-dash": v6Dash,
    "control-settings": controlSettings,

    // powerStat,
    // flatPickr,
    RightBar
  },
  computed: {
    ...mapGetters(["DeviceList", "getUserSession"]),
    // Device: {}
    isShow: {
      get() {
        if (this.$can("am", "sm") || this.$can("manage", "user")) {
          return true;
        } else return false;
      }
    }
  },
  data: function() {
    return {
      initError: true,
      installationData: { name: "Arnergy Solar (Unassigned)" },
      deviceWarning: {},
      powerState: {},
      screenView: {
        code: 0,
        codeName: "System Overview"
      },
      chargerPriority: "01",
      // [00, 01, 02] (utility first, solar first, solar and utility)
      chargerPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "Solar and Utility",
          value: "02"
        }
      ],
      outputPriority: "01",
      outputPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "SBU First",
          value: "02"
        }
      ],
      deviceMode: "00",
      deviceModeList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Inverter Mode",
          value: "00"
        },
        {
          text: "UPS Mode",
          value: "01"
        }
      ],
      show: true,
      expiryToSend: "",
      THIS_WEEK: moment()
        .startOf("week")
        .toDate(),
      THIS_MONTH: moment()
        .startOf("month")
        .toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [
          {
            label: "Loading",
            data: [],
            backgroundColor: "rgba(255, 99, 132, 0.3)",
            borderWidth: 1
          }
        ]
      },
      solarchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [
          {
            label: "Loading",
            data: [],
            backgroundColor: "rgba(255, 99, 132, 0.3)",
            borderWidth: 1
          }
        ]
      },
      timeRightNow: "",
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      Device: {},
      HealthData: [],
      warnings: [],
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },
  methods: {
    ...mapActions(["refreshList"]),

    roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    async getDevice() {
      var inverterId = this.$route.params.deviceId;
      const context = this;
      const HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=${inverterId}`;
      await HTTP.get(url)
        .then(response => {
          if (response.data.length > 0)
            context.installationData = response.data[0];
          //console.log(response.data);
        })
        .catch(error => {
          return "not assign";
          //console.log("error", error);
        });
    },
    async openBlank() {
      let { installationData } = this;
      let { uuid } = installationData.user;
      let { name, CID } = installationData;

      console.log(installationData);

      const URL = `https://oss.arnergy.com/d/_fUnhhknk/grid-metrics?orgId=1&var-uuid=${uuid}&var-name=${name}%20&var-deviceId=${CID}`;
      // const URL=`https://34.216.73.174/d/0Qwnd6XMz/poc?orgId=1&refresh=1m&var-uuid=${uuid}&from=now-1h&to=now&kiosk`;
      // const URL=`https://34.216.73.174/d/0Qwnd6XMz/poc?orgId=1&refresh=1m&var-uuid=${uuid}&from=now-1h&to=now&var-deviceId=${this.$route.params.deviceId}`;
      window.open(URL, "_blank").focus();
    },
    handleSplitValue(param) {
      this.screenView = param;
      // console.log(this.screenView);
    },
    Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags(Warning, type) {
      var excluded = [
        "id",
        "deviceID",
        "DeviceTimeStamp",
        "createdAt",
        "updatedAt"
      ];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0 &&
          search.hasOwnProperty(property)
        ) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    renderChart() {},

    timeAgo(date) {
      var difference = moment(date).fromNow();
      return difference;
    },
    activePower(parameters) {
      var power = this.roundUp((parameters.ACOutputActivePower * 1) / 1000);
      return power + "kW";
    },
    panelPower(parameters) {
      var power = this.roundUp(
        (parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1)) / 1000
      );
      return power + " kW";
    },
    powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl() {
      this.$refs.controlModal.hide();
    },
    control() {
      const HTTP = this.$httpUtils.instance;
      var inverterId = `${this.$route.params.deviceId}`;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = endies;
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = JSON.stringify({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = JSON.stringify({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.chargerPriority}`
          });
          break;
        case "output-priority":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.outputPriority}`
          });
          break;
        case "device-mode":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.deviceMode}`
          });
          break;
        case "ssh":
          requestParam =
            "ipaddress=" +
            this.ipAddress +
            "&username=" +
            this.username +
            "&password=" +
            this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = JSON.stringify({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam)
        .then(response => {
          alert("Sent!!!");
          this.hideControl();
        })
        .catch(e => {
          console.log(e);
        });
    },
    confirmEnergy(data) {
      if (data == undefined) return [];
      return data;
    },

    fetchHealth(type) {
      const container = this;
      const HTTP = this.$httpUtils.instance;
      HTTP.get(`${this.IOTSRC}/health/${this.$route.params.deviceId}/${type}?`)
        .then(response => {
          var respTime = [];
          var Chartdata = response.data;
          var temptime = Chartdata["Time"];
          temptime.forEach(element => {
            respTime.push(moment(element).format("Do MMM hh:mm"));
          });
          container.chartdata = {
            labels: respTime.reverse(),
            datasets: [
              {
                label: "Battery Voltage",
                backgroundColor: "rgba(255, 99, 132, 0.2)",
                data: Chartdata["BatteryVoltage"].reverse()
              },
              {
                label: "PV Charging Power",
                backgroundColor: "rgba(54, 162, 235, 0.2)",
                data: Chartdata["PVChargingPower"].reverse()
              },
              {
                label: "Battery Charging Current",
                backgroundColor: "rgba(255, 206, 86, 0.2)",
                data: Chartdata["BatteryChargingCurrent"].reverse()
              },
              {
                label: "Battery Capacity",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                data: Chartdata["BatteryCapacity"].reverse()
              },
              {
                label: "Output Load Percent",
                backgroundColor: "rgba(153, 102, 255, 0.2)",
                data: Chartdata["OutputLoadPercent"].reverse()
              },
              {
                label: "Grid Voltage",
                backgroundColor: "rgba(255, 153, 0, 0.6)",
                data: Chartdata["GridVoltage"].reverse()
              },
              {
                label: "AC Output ActivePower",
                backgroundColor: "rgba(255, 159, 64, 0.2)",
                data: Chartdata["ACOutputActivePower"].reverse()
              }
            ]
          };
          container.charttype = "line";

          container.renderChart();
        })
        .catch(e => {
          console.log(e);
        });
    },
    expiryDate(deviceID) {
      const deviceExpiry = this.findDeviceData(
        this.DeviceList.expiries,
        "DeviceID",
        deviceID
      );

      return deviceExpiry !== undefined
        ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"])
        : "--";
    },
    findDeviceData(dataset, key, value) {
      const res = dataset.filter(x => x[key] == value);
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    initFetch() {
      var inverterId = this.$route.params.deviceId;
      // console.log(this.refreshList);
      this.Device = {
        parameters: this.findDeviceData(
          this.DeviceList.devices,
          "DeviceID",
          inverterId
        )[0],
        mode: this.findDeviceData(
          this.DeviceList.modes,
          "DeviceID",
          inverterId
        )[0],
        expiry: this.findDeviceData(
          this.DeviceList.expiries,
          "DeviceID",
          inverterId
        )[0]
      };
      // console.log(this.DeviceList);
    },
    getDeviceState() {
      let container = this;
      var inverterId = this.$route.params.deviceId;
      // console.log(inverterId)
      // console.log("=========================================")
      var FASTHTTP = this.$httpUtils.FastAPIHTTP;
      FASTHTTP.get(`/devicestate/${inverterId}`)
        .then(resp => {
          console.log("i am here right now")
          // console.log(resp.data.state.reported.userPower);
          if (resp.data.state.reported.userPower) {
            container.powerState = resp.data.state.reported.userPower;
          }
        })
        .catch(err => console.log(err));
    },
    transformData(data, keys) {
      return data.reduce(
        (aggr, c_item) => {
          keys.map(key => {
            aggr[key] = [...aggr[key], c_item["payload"][key] * 1];
          });
          return aggr;
        },
        keys.reduce((ret, crr) => {
          ret[crr] = [];
          return ret;
        }, {})
      );
    },
    getTimeLabel(data) {
      return data.reduce((aggr, c_item) => {
        aggr = [
          ...aggr,
          moment(c_item["payload"]["TimeStamp"])
            .add(1, "hour")
            .format("h:m:s A")
        ];
        return aggr;
      });
    },
    solarDataChart(displayData, labels) {
      let Chartdata = this.transformData(displayData, [
        "ACOutputActivePower",
        "PVChargingPower"
      ]);
      this.solarchartdata = {
        labels: labels,
        datasets: [
          {
            pointRadius: 0,
            label: "Output Active Power",
            borderColor: "#109cf1",
            backgroundColor: "rgba(16, 156, 241,0.4)",
            data: Chartdata["ACOutputActivePower"]
          },
          {
            pointRadius: 0,
            label: "PV Charging Power",
            borderColor: "#ffb946",
            // backgroundColor: "rgba(0,0,0,0.3)",
            backgroundColor: "rgba(255, 185, 70,0.8)",
            data: Chartdata["PVChargingPower"]
          }
        ]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.solarchartdata.reload(this.solarchartdata, this.charttype);
    },
    batteryChart(displayData, labels) {
      let Chartdata = this.transformData(displayData, [
        "BatteryCapacity",
        "OutputLoadPercent"
      ]);
      this.chartdata = {
        labels: labels,
        datasets: [
          {
            pointRadius: 0,
            label: "Battery Percent",
            borderColor: "#109cf1",
            backgroundColor: "rgba(16, 156, 241,0.4)",
            data: Chartdata["BatteryCapacity"]
          },
          {
            pointRadius: 0,
            label: "Load Percent",
            borderColor: "#ffb946",
            backgroundColor: "rgba(255, 185, 70,0.8)",
            data: Chartdata["OutputLoadPercent"]
          }
        ]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.healthchart.reload(this.chartdata, this.charttype);
    },
    getDeviceData(upperLimit = null, lowerLimit = null, limit = 100) {
      let container = this;
      var inverterId = this.$route.params.deviceId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Parameters",
        KeyConditionExpression:
          "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": `${inverterId}`,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      const FastAPIHTTP = this.$httpUtils.FastAPIHTTP;
      FastAPIHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          let DevData = resp.data.Items;
          // console.log(DevData);
          // console.log(this.getTimeLabel(DevData));
          this.batteryChart(DevData, this.getTimeLabel(DevData));
          this.solarDataChart(DevData, this.getTimeLabel(DevData));
          // console.log(resp.data.state.reported.userPower);
          // if (resp.data.state.reported.userPower) {
          //   container.powerState = resp.data.state.reported.userPower;
          // }
        })
        .catch(err => console.log(err));
    },
    getDeviceWarnings() {
      let app = this;
      var inverterId = this.$route.params.deviceId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Warnings",
        KeyConditionExpression:
          "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": moment().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      const FastAPIHTTP = this.$httpUtils.FastAPIHTTP;
      FastAPIHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          let DevData = resp.data.Items;
          console.log(DevData);
          if (DevData[0]) {
            app.deviceWarning = DevData[0]["payload"];
          }
          // console.log(this.getTimeLabel(DevData))
          // this.batteryChart(DevData, this.getTimeLabel(DevData));
          // this.solarDataChart(DevData, this.getTimeLabel(DevData));
          // console.log(resp.data.state.reported.userPower);
          // if (resp.data.state.reported.userPower) {
          //   container.powerState = resp.data.state.reported.userPower;
          // }
        })
        .catch(err => console.log(err));
    }
    // getDevice() {
    //   var inverterId = this.$route.params.deviceId;
    //   const context = this;
    //   const HTTP = this.$httpUtils.instance;
    //   //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
    //   const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][solarKitIds]=${inverterId}`;
    //   HTTP.get(url)
    //     .then((response) => {
    //       if (response.data.length > 0)
    //         context.installationData = response.data[0];
    //     })
    //     .catch((error) => {
    //       return "not assign";
    //       //console.log("error", error);
    //     });
    // },
  },
  created() {},
  mounted() {
    this.initError = false;
    // try {
    //   this.currentTime();
    // this.refreshList();
    //   this.initFetch();
    this.getDevice();
      // this.getDeviceState();
    //   this.getDeviceData();
    //   this.getDeviceWarnings();
    // } catch (error) {
    //   this.initError = true;
    //   console.log("Init Error", error);
    // }

    // this.fetchAllDeviceData();
    // this.fetchHealth("today");
    // this.statusBorder = "4px solid #000";
    // setInterval(this.fetchAllDeviceData, 60000);
  }
};
</script>

<style lang="scss" scoped>
ul {
  margin-top: 0px !important;
}
.info-div-inner .stats {
  flex-flow: column;
}

address {
  small {
    color: #9b9b9b;
    font-size: 0.75rem;
  }
}

.sm-font-size {
  font-size: 13px;
  margin-left: 13px;
}

.d-flex button {
  width: 100%;
}

button,
.vuestic-switch {
  margin-bottom: 1rem;
}

button,
button i {
  font-size: 0.7em;
}

.btn.btn-with-icon i {
  font-size: 1.5em;
}

.flatpickr-next-month,
.flatpickr-next-month.flatpickr-next-month {
  right: 0 !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.dash_details {
  background: #1a93ca;
  padding: 8px 15px;
  color: #ffffff;
  width: 100%;
  border-radius: 4px 4px 0px 0px;
}
.stats_header__title {
  font-size: 15px;
  color: #a2b5c5;
  font-weight: 600;
  letter-spacing: 0.13px;
}
._user-avatar {
  height: 48px;
  width: 48px;
  border-radius: 50%;
}
.power_stat_ {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.power_stat_row_ {
  display: flex;
  flex-flow: row;
  text-align: left;
  justify-content: space-between;
}
.stat_data_row {
  display: flex;
  justify-content: center;
  width: 100%;
}

@media (max-width: 1399px) {
  .col-xl-3.col-lg-3.col-md-6 {
    width: 50% !important;
  }
}

.top-subtitle {
  font-size: 1rem !important;
}

.sadFaceIOT {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
  min-height: calc(100vh - 250px);
  color: #9b9b9b;
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/detailsV3.vue